import { useEffect, useState } from "react";
import {
  ADD_TO_BASKET_ESI_QUANTITY_UPDATED,
  ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
} from "@/constants/constants";

const QUANTITY_MIN = 1;
const QUANTITY_MAX = 999;

const validQuantity = (value: unknown): value is number =>
  typeof value === "number" &&
  Number.isInteger(value) &&
  value >= QUANTITY_MIN &&
  value <= QUANTITY_MAX;

export const useQuantity = () => {
  const [quantity, setQuantity] = useState<number>(1);

  useEffect(() => {
    const handleQuantityUpdated = (event: Event) => {
      if (!(event instanceof CustomEvent)) return;
      const detail = event.detail;
      if (validQuantity(detail?.quantity)) {
        setQuantity(detail.quantity);
      }
    };

    const handleReset = () => {
      setQuantity(1);
    };

    window.addEventListener(
      ADD_TO_BASKET_ESI_QUANTITY_UPDATED,
      handleQuantityUpdated,
    );
    window.addEventListener(ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED, handleReset);

    return () => {
      window.removeEventListener(
        ADD_TO_BASKET_ESI_QUANTITY_UPDATED,
        handleQuantityUpdated,
      );
      window.removeEventListener(
        ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
        handleReset,
      );
    };
  }, []);

  return { quantity };
};
